import React, { useEffect, useState, useRef } from 'react'
import ReactDOMServer from 'react-dom/server'
import { Tooltip } from 'react-tooltip'
import styled from 'styled-components'

import infoIcon from '../images/info-icon-black.svg'
import infoIconPurple from '../images/info-icon-black-full.svg'

const ReactTooltip = styled.a`
  position: relative;
  border-bottom: none !important;

  &:hover {
    background-color: none !important;
  }

  a {
    border-bottom: 1px solid ${(p) => p.theme.chameleon.colors.pusher.lightBlueishGrey};
  }
`
const InfoIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 2px;
  cursor: pointer;
`
const TooltipLoadable = ({ row, content, withIcon, place }) => {
  const id = content.toLowerCase().replace(/ /gi, '_')
  const [isVisible, setIsVisible] = useState(false)
  const containerRef = useRef(null)

  let text = content

  useEffect(() => {
    if (typeof window === 'undefined' || !containerRef.current) return

    const toggleTooltip = (e) => {
      if (containerRef.current.contains(e.target)) return
      setIsVisible(false)
    }

    document.addEventListener('click', toggleTooltip)
    return () => {
      document.removeEventListener('click', toggleTooltip)
    }
  }, [id])

  if (row?.link?.url && row.link_text) {
    if (text.includes(row.link_text)) {
      text = content.split(row.link_text)
    }

    text = (
      <>
        <a className="tooltip-link" href={row.link.url} target="_blank" rel="noopener noreferrer">
          {row.link_text}
        </a>
        {text[1]}
      </>
    )
  }
  const htmlContent = <div>{text}</div>

  return (
    <ReactTooltip
      data-tooltip-id={id}
      data-tooltip-html={ReactDOMServer.renderToStaticMarkup(htmlContent)}
      onClick={() => {
        setIsVisible(!isVisible)
      }}
      ref={containerRef}
    >
      {withIcon && <InfoIcon src={isVisible ? infoIconPurple : infoIcon} alt="tooltip" />}

      <Tooltip id={id} className="react-tooltip" effect="solid" place={place} isOpen={isVisible} />
    </ReactTooltip>
  )
}

export default TooltipLoadable
